import { ClipboardList, Repeat } from 'lucide-react';
import { personInitials, type ChurchEvent } from '../lib/calendar';

export function RecurrenceBadge({ event }: { event: ChurchEvent }) {
  if (!event.recurring) return null;
  return (
    <span className="event-recurrence-badge">
      <Repeat size={14} aria-hidden="true" />
      Recurrente{event.recurrenceLabel ? ` · ${event.recurrenceLabel}` : ''}
    </span>
  );
}

export function RegistrationBadge({ event }: { event: ChurchEvent }) {
  if (!event.registrationUrl) return null;
  return (
    <span className="event-register-badge">
      <ClipboardList size={14} aria-hidden="true" />
      Requiere inscripción
    </span>
  );
}

function PeopleGroup({
  names,
  label,
  variant,
}: {
  names: string[];
  label: string;
  variant: 'organizer' | 'guest';
}) {
  if (!names.length) return null;

  return (
    <div className={`event-people-group is-${variant}`}>
      <small>{label}</small>
      <ul>
        {names.map((name) => (
          <li key={`${variant}-${name}`}>
            <span aria-hidden="true">{personInitials(name)}</span>
            <strong>{name}</strong>
          </li>
        ))}
      </ul>
    </div>
  );
}

export function EventPeople({ event }: { event: ChurchEvent }) {
  if (!event.organizers.length && !event.guests.length) return null;

  return (
    <div className="event-people">
      <PeopleGroup
        names={event.organizers}
        label={event.organizers.length > 1 ? 'Organizan' : 'Organiza'}
        variant="organizer"
      />
      <PeopleGroup
        names={event.guests}
        label={event.guests.length > 1 ? 'Invitados' : 'Invitado'}
        variant="guest"
      />
    </div>
  );
}
